<template>
  <div class="card">
    <div class="card-body">
      <h5 class="text-muted">{{productName}}</h5>
      <div class="metric-value d-inline-block">
        <h1 class="mb-1">R${{totalValue.toFixed(2)}}</h1>
      </div>
      <!-- <div class="metric-label d-inline-block float-right text-success font-weight-bold">
        <span>
          <i class="fa fa-fw fa-arrow-up"></i>
        </span>
        <span>5.86%</span>
      </div>-->
    </div>
    <div class="chart-sales-product">
      <line-chart
        v-if="chartData"
        style="display: inline-block; width: 100%; height: 100px !important; vertical-align: top;"
        :chart-data="datacollection"
        :options="options"
      ></line-chart>
      <loading v-else :color="'#1abdde'" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "../../../../assets/styles/partials/pages/_salesdash.scss";
</style>

<script>
import LineChart from "../LineChart.js";
import axios from "axios";
import moment from 'moment';

export default {
  props: {
    productName: {
      type: String,
      required: false
    },
    chartData: {
      type: Array,
      required: false
    },
    loadingData: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      dataProcessed: [],
      totalValue: 0,
      labelsProcessed: [],
      datacollection: { labels: [], datasets: [] },
      options: {
        elements: {
          line: {
            borderColor: "#000000",
            borderWidth: 1
          },
          point: {
            radius: 2
          }
        },
        scales: {
          xAxes: [
            {
              display: false
            }
          ],
          yAxes: [
            {
              display: false
            }
          ]
        },
        legend: {
          display: false
        },
        maintainAspectRatio: false
      }
    };
  },
  components: {
    LineChart
  },
  methods: {},
  created() {
    for (let i = 0; i < this.chartData.length; i++) {
      let valueOrders = this.chartData[i].orders;

      if (!this.chartData[i].orders) valueOrders = 0;

      if (this.chartData[i].value) this.totalValue += this.chartData[i].value;

      this.dataProcessed.push(valueOrders);

      let stringDate = moment(String(this.chartData[i].day)).format('DD/MM/YYYY');


      this.labelsProcessed.push(stringDate);
    }

    this.datacollection = {
      labels: this.labelsProcessed,
      datasets: [
        {
          label: "Vendas",
          backgroundColor: "#f87979",
          data: this.dataProcessed
        }
      ]
    };
  }
};
</script>
